import { defineStore } from 'pinia'
import {setupAxios} from "@/modules/axios.ts";

interface IAppState {
  name?: string
  storage?: string
  session?: any
  csrfToken?: string
  locale: string
  defaultLocale: string
  allowedLanguages: any[]
  public_app_url?: string
  admin_api_url?: string
  permissions?: any[]

}

export const useAppStore = defineStore({
  id: 'appStore',

  state: (): IAppState => ({
    name: '',
    storage: '',
    session: {
      status: null,
    },
    csrfToken: undefined,
    locale: 'hu',
    defaultLocale: 'hu',
    allowedLanguages: [],
    public_app_url: '',
    admin_api_url: undefined,
    permissions: [],
  }),
  actions: {

    setState (data?: any): void {
      this.name = data?.name
      this.storage = data?.storage
      this.session = data?.session
      this.csrfToken = data?.csrfToken
      this.locale = data?.locale ?? 'hu'
      this.defaultLocale = data?.defaultLocale ?? 'hu'
      this.allowedLanguages = data?.allowedLanguages ?? []
      this.public_app_url = data?.public_app_url ?? ''
      this.admin_api_url = data?.admin_api_url ?? this.admin_api_url ?? undefined
      this.permissions = data?.permissions ?? []
    },



    setAdminApiUrl(url: string): void {
      this.admin_api_url = url
    },

    setCsrfToken (token: string): void {
      this.csrfToken = token
    },

    setValue<K extends keyof IAppState>(key: K, value: IAppState[K]): void {
      this[key] = value
    },
  },
})
